"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var hydrationHelpers_1 = require("../hydrationHelpers");
var classnames_1 = __importDefault(require("classnames"));
var Expander_1 = require("ContentTokens/SharedWidgetComponents/Expander");
var withCentredAccordionButton_1 = __importDefault(require("ContentTokens/SharedWidgetComponents/Accordion/withCentredAccordionButton"));
var ImageCdnHelper_1 = require("@CommonFrontendBackend/Utils/ImageCdnHelper");
var styles = __importStar(require("ContentTokens/SharedWidgetComponents/Accordion/accordion.css"));
var styleUtilities_1 = require("ContentTokens/SharedWidgetComponents/Accordion/styleUtilities");
var dynamic_1 = require("@vanilla-extract/dynamic");
var accordion_css_1 = require("ContentTokens/SharedWidgetComponents/Accordion/accordion.css");
var Accordion = (function (_super) {
    __extends(Accordion, _super);
    function Accordion(props) {
        var _this = _super.call(this, props) || this;
        _this.handleToggle = function (event) {
            event.stopPropagation();
            _this.expanded = !_this.expanded;
        };
        var defaultExpanded = props.isPrintMode;
        _this.expanded = defaultExpanded;
        return _this;
    }
    Object.defineProperty(Accordion.prototype, "imageUrl", {
        get: function () {
            var _a = this.props, isPrintMode = _a.isPrintMode, disableImgix = _a.disableImgix, backgroundImageUrl = _a.backgroundImageUrl, printOrientation = _a.printOrientation;
            if (backgroundImageUrl) {
                var imageOptions = void 0;
                if (isPrintMode) {
                    var maxWidth = (0, ImageCdnHelper_1.getMaxWidthForPrint)(printOrientation);
                    imageOptions = { maxWidth: maxWidth, keepOriginalFormat: true };
                }
                return (0, ImageCdnHelper_1.getImageSrc)(backgroundImageUrl, disableImgix, imageOptions);
            }
        },
        enumerable: false,
        configurable: true
    });
    Accordion.prototype.render = function () {
        var _a, _b, _c, _d;
        var _e = this, expanded = _e.expanded, _f = _e.props, id = _f.id, heading = _f.heading, body = _f.body, buttonTopMargin = _f.buttonTopMargin, attributes = _f.attributes, widgetAttributes = _f.widgetAttributes, style = _f.style;
        var buttonId = "accordion-button-".concat(id);
        var bodyColor = (0, styleUtilities_1.calculateBodyColor)(style);
        return (react_1.default.createElement("div", __assign({ "data-qwilr-component-state": expanded, "data-qwilr-component": "accordion" }, widgetAttributes, { className: (0, classnames_1.default)("accordion-widget__content project-block__block-element", widgetAttributes.className) }, attributes),
            react_1.default.createElement("div", { role: "heading" },
                react_1.default.createElement("button", { className: (0, classnames_1.default)("accordion-widget-heading", styles.accordionHeading({
                        buttonPosition: (0, styleUtilities_1.calculateButtonPosition)(style),
                        expanded: Boolean(expanded),
                        type: style.cardStyle === "visual" ? "visual" : style.headerBackground.on ? "simple" : "transparent",
                    }), styles.accordionHeadingPublic({
                        buttonPosition: (0, styleUtilities_1.calculateButtonPosition)(style),
                        type: style.cardStyle === "visual" ? "visual" : style.headerBackground.on ? "simple" : "transparent",
                    })), onClick: this.handleToggle.bind("header"), id: buttonId, "aria-expanded": expanded, "aria-controls": id, style: __assign(__assign({}, (style.cardStyle === "visual" && {
                        backgroundImage: "url(".concat(this.imageUrl, ")"),
                    })), (0, dynamic_1.assignInlineVars)((_a = {},
                        _a[accordion_css_1.computedVars.focusColor] = (0, styleUtilities_1.calculateFocusColor)(style),
                        _a))) },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)("accordion-widget-heading__button-wrapper", styles.buttonWrapper({
                            buttonType: style.buttonStyle,
                            type: style.cardStyle,
                        })), style: { marginTop: buttonTopMargin }, onClick: this.handleToggle.bind("button") },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)("accordion-widget-heading__button", (_b = {},
                                _b["accordion-widget-heading__button--expanded"] = expanded,
                                _b["accordion-widget-heading__button--collapsed"] = !expanded,
                                _b), styles.headingButton({
                                buttonType: style.buttonStyle,
                                expanded: Boolean(expanded),
                            })), style: __assign({}, (0, dynamic_1.assignInlineVars)((_c = {},
                                _c[accordion_css_1.computedVars.buttonExpandIcon] = (0, styleUtilities_1.getAccordionExpandedButtonIcon)(style),
                                _c[accordion_css_1.computedVars.buttonCollapseIcon] = (0, styleUtilities_1.getAccordionCollapsedButtonIcon)(style),
                                _c[accordion_css_1.computedVars.buttonTextColor] = (0, styleUtilities_1.goldilocksButtonText)(style),
                                _c[accordion_css_1.computedVars.textLabelIconBackground] = (0, styleUtilities_1.getTextLabelIconBackground)(style),
                                _c))) })),
                    react_1.default.createElement(hydrationHelpers_1.ContentArea, { className: (0, classnames_1.default)("accordion-widget-heading__content", styles.headingContent({
                            type: style.cardStyle,
                        })) }, heading))),
            react_1.default.createElement(Expander_1.Expander, { open: expanded },
                react_1.default.createElement(hydrationHelpers_1.ContentArea, { className: (0, classnames_1.default)("accordion-widget-body", styles.accordionBody({
                        buttonPosition: (0, styleUtilities_1.calculateButtonPosition)(style),
                        type: style.cardStyle === "visual" ? "visual" : style.headerBackground.on ? "simple" : "transparent",
                    }), styles.accordionBodyPublic), style: __assign({}, (bodyColor &&
                        (0, dynamic_1.assignInlineVars)((_d = {},
                            _d[accordion_css_1.computedVars.bodyBackground] = bodyColor,
                            _d)))), id: id, role: "region", "aria-labelledby": buttonId }, body))));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], Accordion.prototype, "expanded", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Accordion.prototype, "handleToggle", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Accordion.prototype, "imageUrl", null);
    Accordion = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Accordion);
    return Accordion;
}(react_1.default.Component));
exports.default = (0, hydrationHelpers_1.withHydrationHost)((0, withCentredAccordionButton_1.default)(Accordion), {
    componentName: "Accordion",
    ignoreProps: ["heading", "body"],
});
